import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { fetchFullBridgeConvertersBySerialNumber } from '../api/hardware-components.api'
import { FullBridgeConverter } from '../models'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { usePortalQuery } from 'src/Libs/api'

type DataReturnType = [FullBridgeConverter[] | null, boolean]

export const useFullBridgeConvertersBySerialNumber = (serialNumber?: string): DataReturnType => {
  const { t } = useCustomTranslation()
  const authFetch = useAuthFetchWithResponse()
  const serialNumberToUse = serialNumber ? parseInt(serialNumber) : undefined

  const fetchFullBridgeConvertersBySerialNumberQueryFn = async (): Promise<FullBridgeConverter[] | null> => {
    const { error, hasErrors, value } = await fetchFullBridgeConvertersBySerialNumber(serialNumberToUse, authFetch, t)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred when fetching full bridge converters')
    }

    return value
  }

  const { data, isLoading } = usePortalQuery({
    queryKey: ['storages', serialNumber, 'hardware', 'dcdcs'],
    queryFn: fetchFullBridgeConvertersBySerialNumberQueryFn,
    enabled: !!serialNumber,
  })

  return [data || null, isLoading]
}
